export default {"src":"/_next/static/media/0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};